// Copyright (c) 2022-23, iPivot, Corp.
'use strict'

import axios from 'axios'
import { useEffect, useState } from 'react'

import { availableThemes, getDefaultTheme } from '@ipivot/themes-browser'

export const useTheme = (fetchUserSettings = true) => {
    const [theme, setTheme] = useState({})

    useEffect(() => {
        const fetchThemes = async () => {
            let themes = []
            let userSettings = {}

            try {
                themes = await availableThemes()
                userSettings = fetchUserSettings ? (await axios.get('/settings')).data : {}
            } catch (e) {
                //Do nothing but fallback to the default theme
            }

            const userSelectedTheme = themes.find(theme => theme.id === userSettings.selectedTheme)

            if (userSelectedTheme) {
                setTheme(userSelectedTheme.theme)
            } else {
                setTheme((await getDefaultTheme()).theme)
            }
        }

        fetchThemes()
    }, [fetchUserSettings])

    return theme
}
